export default [
  {
    path: "/competitors",
    name: "competitors.index",
    redirect: "/competitors/products",
    icon: "award",
    meta: {
      title: "Competitors",
      parentMenu: true,
      ability: {
        action: "read",
        subject: [
          "CompetitorsProducts",
          "CompetitorsBrands",
          "CompetitorsConnections",
        ],
      },
    },
    children: [
      {
        path: "/competitors/products",
        name: "competitors.products.index",
        icon: "circle",
        component: () =>
          import("@/views/competitors/CompetitorsProductsList.vue"),
        meta: {
          title: "Products",
          pageTitle: "Competitor Products",
          ability: { action: "read", subject: "CompetitorsProducts" },
        },
      },
      {
        path: "/competitors/brands",
        name: "competitors.brands.index",
        icon: "bookmark",
        component: () =>
          import("@/views/competitors/CompetitorsBrandsList.vue"),
        meta: {
          title: "Brands",
          pageTitle: "Competitor Brands",
          ability: { action: "read", subject: "CompetitorsBrands" },
        },
      },
      {
        path: "/competitors/connections",
        name: "competitors.connections.index",
        icon: "link",
        component: () =>
          import("@/views/competitors/CompetitorsConnectionsList.vue"),
        meta: {
          title: "Connections",
          pageTitle: "Competitor Connections",
          ability: { action: "read", subject: "CompetitorsConnections" },
        },
      },
    ],
  },
];
